module.exports = __webpack_public_path__ + "static/media/404.f75c692e.png";